<template>
  <div v-if="isOpen" class="modal-container">
    <div class="modal">
      <h2 class="heading-2 text-warning-red text-2xl font-bold leading-none">CAUTION!</h2>
      <p
        class="mt-2"
      >Please examine your account within 15 minutes of purchase and after verifying everything is as described, change the password and verify the email before you play on it. This is for security reasons and failing to do so will result in your lifetime warranty being null and void.</p>
      <p
        class="mt-4"
      >Transferring an account to a different region voids the warranty, we advise you to not transfer the account - the account can be lost / locked.</p>

      <label for="checkbox" :class="['flex items-center mt-4', errored && 'text-warning-red']">
        <input type="checkbox" id="checkbox" v-model="checked" class="mr-2">
        I understand and agree to change my email and password
      </label>

      <div class="flex justify-center mt-8">
        <div class="simple-btn btn-gold" @click="dismiss()">Continue</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: true,
      checked: false,
      errored: false,
    };
  },

  methods: {
    dismiss() {
      if (!this.checked) {
        this.errored = true;
        return;
      }

      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-container {
  @apply fixed inset-0;
  background: rgba(0, 0, 0, 0.4);
}

.modal {
  @apply bg-almost-black;
  @apply border-2 border-smurfs-gold;
  @apply p-5;
  @apply text-left;

  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-height: 300px;
  min-width: calc(100% - 20px);
}

@screen md {
  .modal {
    min-width: 500px;
  }
}
</style>
